export default "__VITE_ASSET__DCRy9QkI__"